import { Colors } from "@utils";
import React from "react";
import styled from "styled-components";

interface ButtonProps {
  bgColor: string;
  color: string;
  children: React.ReactNode;
  onClick?: () => any;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const Container = styled.div<{
  bgColor: string;
  color: string;
  disabled: boolean;
}>`
  height: 48px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  background: ${(props) => (props.disabled ? Colors.disabled : props.bgColor)};
  color: ${(props) => props.color};
`;

const Button = function (props: ButtonProps) {
  const {
    bgColor,
    color,
    onClick,
    children,
    className,
    style,
    disabled,
    ...rest
  } = props;

  return (
    <Container
      className={className}
      bgColor={bgColor}
      color={color}
      disabled={!!disabled}
      style={style ?? {}}
      onClick={disabled ? undefined : onClick}
      {...rest}
    >
      {children}
    </Container>
  );
};

export default Button;
